import React, { useState } from "react";
import PollOptions from "../PollOptions/PollOptions";
import "./CreateForm.scss";
import {API_URL} from '../../utils/axios'
import axios from 'axios'
import DatePicker from "react-datepicker";
import Select from 'react-select';
 
const options = [
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
];

const CreateForm = () => {
  const [title, setTitleChange] = useState("");
  const [description, setDescription] = useState("");
  const [location, setLocation] = useState("");
  const [endDateTime, setEndDateTime] = useState(new Date());
  const [pollOption, setPollOption] = useState("");
  const [pollInputChange, setPollInputChange] = useState("");
  const [chooseOptions, setChooseOptions] = useState("");

  console.log(pollInputChange);
//   useEffect(() => {
//     axios.get(API_URL + '/yelp').then(response.data).catch(error)
//   }, [])

  const handleTitleChange = (e) => {
    setTitleChange(e.target.value);
  };

  const handleDescriptionChange = (e) => {
    setDescription(e.target.value);
  };

  const handleLocationChange = (e) => {
    setLocation(e.target.value);
  };

  const handleEndDateTimeChange = (e) => {
    setEndDateTime(e);
  };

  const handlePollInputChange = (e) => {
    setPollInputChange(e);
    // axios.get(API_URL + '/yelp').then(response => setLocationArray(response.data.businesses)).catch(error)
  
  };

  const handlePollOptionChange = (e) => {
   // setPollOption(e);
    setPollOption(e);
   };

  const handleChooseOptionChange = (e) => {
    setChooseOptions(e);
  };

  const handleSubmit = (e) => {
e.preventDefault();
      const poll = {
        title : title,
        description : description,
        location: location,
        endDateTime : endDateTime,
        pollOption : pollOption,
      }
      axios.defaults.headers['foodrtoken'] = localStorage.getItem("token");
      axios.post(API_URL + '/poll/create', {
        ...poll
      }).then(response => {
       window.location = "/share/" + response.data._id
      }).catch(error => {
          console.log(error)
      })
  }
  return (
    <form className="form" onSubmit={handleSubmit}>
      <div className="form__container">
        <div className="form__title">
          <label className="form__subheader">Title</label>
          <input
            name="title"
            type="text"
            placeholder="Type your question here..."
            className="form__input"
            onChange={handleTitleChange}
            value={title}
          />
        </div>
        <div className="form__description">
          <label className="form__subheader">Description (optional)</label>
          <textarea
            name="description"
            type="text"
            placeholder="What is this poll for?"
            className="form__input form__input--description"
            rows="5"
            onChange={handleDescriptionChange}
            value={description}
          ></textarea>
        </div>
        <div className="form__location">
          <label className="form__subheader">Location (Required)</label>
          <input
            name="location"
            className="form__input"
            type="text"
            placeholder="Enter your location"
            required="required"
            onChange={handleLocationChange}
            value={location}
          ></input>
        </div>
        <div className="form__time">
          <label className="form__subheader">End date/time</label>
         <div className="date-picker"><DatePicker
      selected={endDateTime}
      onChange={handleEndDateTimeChange}
      timeInputLabel="Time:"
      dateFormat="MM/dd/yyyy h:mm aa"
      showTimeInput
      inline
      className="form__calendar"
    /></div> 
          
        </div>
        <div className="form__answer">
          <label className="form__subheader">Poll Options</label>
          <Select
        value={chooseOptions}
        onChange={handleChooseOptionChange}
        options={options}
      />
        </div>
        <div class="form__poll-options">
          {<PollOptions handlePollInputChange={handlePollInputChange} number={chooseOptions.label} handlePollOptionChange={handlePollOptionChange}
            location={location} pollOption={pollOption}/>}
        </div>
        <div class="form__button-container">
          <button type="submit" className="form__button">
            Create Poll
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateForm;
